export const LOGOUT_MESSAGE = 'logout';
